import React, { useMemo } from 'react';
import styles from './PatientMedicalHistoryVersion.module.scss';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import ReactDiffViewer from 'react-diff-viewer';
import Text from '../../../../Components/Base/Text/Text';
import useFilters from '../../../Base/Hooks/useFilters';
import { DocumentExtraItemType } from '../../../Documents/Enums/documentExtraItemType.enum';

export interface PatientMedicalHistoryVersionItem {
	id: string;
	updatedAt: string;
	createdBy: {
		profile: {
			fullName: string;
		};
	};
	items: {
		id: string;
		type: string;
		extra: {
			order: number;
			text: string;
			previousText?: string;
			type: string;
			title: string;
		};
	}[];
}

interface Props {
	item: PatientMedicalHistoryVersionItem;
}

const PatientMedicalHistoryVersion: React.FC<Props> = ({ item }) => {
	const { checkEmptyString } = useFilters();

	const finalItems = useMemo(() => {
		const temp: {
			id: string;
			title: string;
			label: string;
			previousText?: string;
			text: string;
		}[] = [];

		const items = item.items.filter(
			i =>
				i.extra.type === DocumentExtraItemType.MEDICAL_HISTORY_ITEM &&
				i.extra.previousText !== 'undefined' &&
				i.extra.text,
		);

		items.forEach(i => {
			const previousText = i.extra.previousText ?? '';
			const label = checkEmptyString(previousText)
				? 'component.patientMedicalHistory.edited'
				: 'component.patientMedicalHistory.added';
			temp.push({
				id: i.id,
				title: i.extra.title,
				label,
				previousText,
				text: i.extra.text,
			});
		});
		return temp;
	}, [item]);

	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<div>
					<FormattedMomentDate
						date={item.updatedAt}
						format={DateFormat.DATE_TIME}
					/>
				</div>
				<div>{item.createdBy.profile.fullName}</div>
			</div>
			<div className={styles.content}>
				{finalItems?.map(i => {
					return (
						<div key={item.id} className={styles.item}>
							<div className={styles.title}>
								{i.title} -{' '}
								<Text tx={i.label} style={{ color: '#d81616' }} inline colon />
							</div>
							<div>
								<ReactDiffViewer
									oldValue={i.previousText}
									newValue={i.text}
									hideLineNumbers
									splitView={false}
								/>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default PatientMedicalHistoryVersion;
